/**
 * Created by intellicar-rinas on 17/1/18.
 */
import React, {Component} from 'react';
import './InWidgetWrapper.css';

class InWidgetWrapper extends Component {

    state = {};

    constructor() {
        super();
    }

    render() {
        return (
            <div className="InWidgetWrapper">
                <div className="iww-head">{this.props.data.name}</div>
                <div className="iww-container">{this.props.children}</div>
            </div>
        )
    }

}

export default InWidgetWrapper;